import {CSV, UPLOAD_CUSTOMER_CSV} from "../../actions/CsvActions";
import {apiRequest, POST} from "../../actions/ApiCallsActions";
import {API_CALL_ERROR, API_CALL_SUCCESS} from "../../actions/ApiCallsActions";
import {mapCsvCustomerToState, mapCsvDataToBusinessCustomers} from "../../../utils/customersUtils";
import {insertCustomers} from "../../actions/CustomersActions";
import endpoints from "../../../endpoints";


export default ({dispatch}) => next => action => {
    next(action);
    const {type, payload} = action;

    switch (type) {
        case UPLOAD_CUSTOMER_CSV:
            // API call started
            dispatch(apiRequest(endpoints.uploadCsv, POST, CSV, payload.data));
            break;
        case `${CSV} ${API_CALL_SUCCESS}`: {
            // normalize return data
            let {data, companyId} = action.payload;
            console.log("csv upload success");

            // update customer state
            const customer = mapCsvCustomerToState(data);
            dispatch(insertCustomers(customer));

            // call create business customer
            const customersForCreation = mapCsvDataToBusinessCustomers(data);
            //dispatch(createCustomers(companyId, customersForCreation))
            break
        }
        case `${CSV} ${API_CALL_ERROR}`: {

        }
    }
};
